import React, { PureComponent } from 'react'
import { string, func } from 'prop-types'
import SendEmail from '../common/SendEmail'

class ForgotPassword extends PureComponent {
  static propTypes = {
    configureTrack: func.isRequired,
    username: string,
  }

  static defaultProps = {
    username: '',
  }

  componentDidMount() {
    const { configureTrack } = this.props
    configureTrack({
      eventName: 'ForgetPassword',
      widget: 'forget_password',
      pageType: 'forget password',
    })
  }

  render() {
    const { username, ...rest } = this.props

    const params = {}
    if (username) {
      params.fields = { email: username || rest.fields.email }
    }

    return (
      <SendEmail
        title="passport.forgotPwd.title"
        subTitle="passport.forgotPwd.subTitle"
        {...rest}
        {...params}
      />
    )
  }
}

export default ForgotPassword
